import React, { useState } from "react";
import "./RequestCallBack.css";
import FooterSection from "../FooterSection/FooterSection";
import logo1 from "../../assets/logo1.png"
const RequestCallBack = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    alternative: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.fullName.trim()) {
      err.fullName = "Full Name is required";
    }

    if (!formData.email.trim()) {
      err.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      err.email = "Enter valid email address";
    }

    if (!formData.mobile.trim()) {
      err.mobile = "Mobile Number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      err.mobile = "Enter valid 10 digit mobile number";
    }

    if (!formData.message.trim()) {
      err.message = "Message is required";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

const handleSubmit = (e) => {
  e.preventDefault();

  if (validate()) {
    alert("Form Submitted Successfully!");

    // ✅ Clear form fields
    setFormData({
      fullName: "",
      email: "",
      mobile: "",
      alternative: "",
      subject: "",
      message: "",
    });

    // ✅ Clear errors
    setErrors({});
  }
};


  return (
    <div className="request-wrapper">
      {/* Navbar */}
      <div className="navbar">
        <div className="logo">
          <div className="circle">
            <img src={logo1} alt="logo-zikrme" className="zikrme-logo-image"/>
          </div>
          <span>Request Call Back</span>
        </div>

        <div className="nav-right">
          <a href="#">Home</a>
          <a href="#">About</a>
          <a href="#">Contact</a>
          <input type="text" placeholder="Search in site" />
        </div>
      </div>

      {/* Center Title */}
      <div className="page-title">
        <h1>Request Call Back</h1>
      </div>

      {/* Form */}
      <form className="form-container" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Full Name *</label>
          <div className="input-section">
            <input
              type="text"
              name="fullName"
              placeholder="Enter Your Name"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <p className="error">{errors.fullName}</p>}
          </div>
        </div>

        <div className="form-group">
          <label>Email Address *</label>
          <div className="input-section">
            <input
              type="text"
              name="email"
              placeholder="Enter Your Email id"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>
        </div>

        <div className="form-group">
          <label>Mobile Number *</label>
          <div className="input-section">
            <input
              type="text"
              name="mobile"
              placeholder="Enter Your Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
            />
            {errors.mobile && <p className="error">{errors.mobile}</p>}
          </div>
        </div>

        <div className="form-group">
                  <label>Alternative No.</label>
                   <div className="input-section">
          <input
            type="text"
            name="alternative"
            placeholder="Enter Your Additional no."
            value={formData.alternative}
            onChange={handleChange}
                      />
                      </div>
        </div>

        <div className="form-group">
                  <label>Subject</label>
                   <div className="input-section">
          <input
            type="text"
            name="subject"
            placeholder="Enter Your Subject"
            value={formData.subject}
            onChange={handleChange}
          />
                  </div>
                  </div>

        <div className="form-group">
          <label>Message</label>
          <div className="input-section">
            <textarea
              name="message"
              placeholder="Enter Your Message"
              value={formData.message}
              onChange={handleChange}
            />
            {errors.message && <p className="error">{errors.message}</p>}
          </div>
        </div>

        <div className="submit-area">
          <button type="submit">Submit</button>
        </div>
          </form>
          <FooterSection/>
    </div>
  );
};

export default RequestCallBack;
